import React, { useState } from 'react';
import { connect } from 'react-redux';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import { Tooltip } from '@material-ui/core';
import languages from '../../../app/i18n/languages';
import { actions as authReduxActions } from '../../../app/pages/auth/reducers';
import { translate } from '../../../app/i18n/I18nProvider';

const styles = {
  langSwitcher: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginRight: '12px'
  },
  hideOnMobile: {
    '@media (max-width: 1024px)': {
      display: 'none'
    }
  },
  selectedFlag: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    '&:hover': { background: 'rgba(255,255,255,0.15)' }
  },
  dropdown: {
    position: 'absolute',
    top: 'calc(100% + 6px)',
    right: 0,
    background: '#fff',
    border: '1px solid #e2e5ec',
    borderRadius: '6px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    zIndex: 200
  },
  dropdownItem: {
    background: 'none',
    border: 'none',
    padding: '6px 10px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '&:hover': { background: '#f4f6fc' }
  },
  dropdownItemActive: {
    background: '#eef2ff'
  },
  backdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 199
  },
  flagImg: {
    display: 'block',
    width: 'auto',
    height: '22px',
    maxWidth: 'none'
  },
  flagImgSmall: {
    display: 'block',
    width: 'auto',
    height: '18px',
    maxWidth: 'none'
  }
};

const LangSwitcher = ({
  classes,
  lang,
  setLanguage,
  small = false,
  hideOnMobile = false
}) => {
  const [open, setOpen] = useState(false);
  const currentLang = languages.find(l => l.lang === lang) || languages[0];
  const imgClass = small ? classes.flagImgSmall : classes.flagImg;

  return (
    <div
      className={`${classes.langSwitcher}${
        hideOnMobile ? ` ${classes.hideOnMobile}` : ''
      }`}
    >
      {open && (
        <>
          <div className={classes.backdrop} onClick={() => setOpen(false)} />
          <div className={classes.dropdown}>
            {languages.map(language => (
              <Tooltip
                key={language.lang}
                title={language.name}
                placement="left"
              >
                <button
                  className={`${classes.dropdownItem} ${
                    lang === language.lang ? classes.dropdownItemActive : ''
                  }`}
                  onClick={() => {
                    setLanguage(language.lang);
                    setOpen(false);
                  }}
                >
                  <img
                    src={language.flag}
                    alt={language.name}
                    className={imgClass}
                  />
                </button>
              </Tooltip>
            ))}
          </div>
        </>
      )}
      <Tooltip title={translate('BUTTON.CHANGE_LANGUAGE')} placement="bottom">
        <button
          className={classes.selectedFlag}
          onClick={() => setOpen(o => !o)}
        >
          <img
            src={currentLang.flag}
            alt={currentLang.name}
            className={imgClass}
          />
        </button>
      </Tooltip>
    </div>
  );
};

const mapStateToProps = ({ auth }) => ({
  lang: auth.lang
});

const mapDispatchToProps = {
  setLanguage: authReduxActions.setLanguage
};

export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(LangSwitcher);
